import { Slider } from '@mui/material'
import { withStyles } from '@mui/styles'

const StyledSlider = withStyles({
    root: {
        '& .MuiSlider-thumb': {
            height: 12,
            width: 12,
            backgroundColor: '#fff',
            border: '2px solid currentColor',
            marginTop: 0,
            marginLeft: 0,
            '&:focus, &:hover, &.Mui-active': {
                boxShadow: 'inherit',
            },
        },
        '& .MuiSlider-track': {
        height: 2,
        borderRadius: 2
        },
        '& .MuiSlider-rail': {
        height: 4,
        borderRadius: 2,
        },
        marginLeft: 14,
        marginRight: 7
    }
  })(Slider);

  export default StyledSlider